import React from 'react';
import { useOfferContext } from '../../../context';
import { plural } from '@cian/utils';
import { SpecialGeo } from '../../../components/SpecialGeo';
import { Train16 } from '@cian/ui-kit/icons';

export function RailwayContainer() {
  const { railway, tracking, qsToUris } = useOfferContext();

  const url = React.useMemo(() => {
    if (railway) {
      return (qsToUris && qsToUris[railway.qs]) || `/cat.php?${railway.qs}`;
    }

    return '';
  }, [qsToUris, railway]);

  const remoteness = React.useMemo(() => {
    if (railway && railway.time && railway.time > 0) {
      const unit = plural(railway.time, ['минута', 'минуты', 'минут']);
      const transportType = railway.travelType === 'byFoot' ? 'пешком' : 'на транспорте';

      return `${railway.time} ${unit} ${transportType}`;
    }

    return undefined;
  }, [railway]);

  const handleUndergroundClick = React.useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      tracking.trackAddressClick('railway');
    },
    [tracking.trackAddressClick],
  );

  if (!railway) {
    return null;
  }

  return (
    <SpecialGeo
      url={url}
      label={railway.name}
      icon={<Train16 color="gray_icons_100" />}
      remoteness={remoteness}
      onClick={handleUndergroundClick}
    />
  );
}
